export enum ErrorType {
  NO_ERROR = 'NO_ERROR',
  FAILED_TO_GET = 'FAILED_TO_GET',
  UNABLE_TO_SAVE = 'UNABLE_TO_SAVE',
}
export interface SavedViewButtonsTrackingTags {
  [key: string]: string | string[];
  access?: string;
  locationId?: string;
  pageName?: string;
  itemGroup?: string;
  section?: string;
  subsection?: string;
}
export type CreateViewStateFn<TViewState extends object> = (dataType?: DataType) => TViewState;

interface BaseView<TViewState extends object> {
  /**
   * Callback handler for creating a view state
   */
  createViewStateFn: CreateViewStateFn<TViewState>;
  getTrackingTags?: () => SavedViewButtonsTrackingTags;
  defaultDataType?: DataType;
}

export enum CopyLinkActionType {
  Button = 'Button',
  ButtonIconOnly = 'ButtonIconOnly',
  MenuItem = 'MenuItem',
}

export interface CopyLinkActionProps<TViewState extends object> extends BaseView<TViewState> {
  actionType: CopyLinkActionType;
}

export interface CopyLinkMeta {
  purpose: string;
}

export interface DirectLinkMeta {
  purpose: string;
  pathname: string;
  search: string;
}

export type DataType = 'static' | 'live';

export interface PageView<TViewState extends object> {
  key: string;
  created_at: Date;
  dataType: DataType;
  data: TViewState;
  meta?: CopyLinkMeta | DirectLinkMeta;
}
